import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader.js';

/**
 * Chrome for the account-level pages (`/businesses`, `/businesses/new`) that sit
 * outside a business shell. Reuses the shared {@link AppHeader} so the bar and
 * brand match the business pages exactly — it just has no switcher or section
 * nav, because there's no active business yet.
 */
export function AccountLayout() {
  return (
    <div className="app-shell">
      {/* The only bar that shows the full wordmark, phone included: no switcher,
          no section nav, nothing to crowd it — and this is where an owner
          arrives before any business is in context. */}
      <AppHeader brand="full" />
      <main className="page">
        <Outlet />
      </main>
    </div>
  );
}
